import { rest } from 'msw';
import { AGENTS_API_URL } from '../../config';

export const documentHandler = [
    rest.get(AGENTS_API_URL + '/documents/search*', async (req, res, ctx) => {
        return res(
            ctx.status(200),
            ctx.json({
                data: [
                    {
                        _id: '680fc354a3f7a8f732512611',
                        name: 'lorem-ipsum.pdf',
                        title: 'lorem-ipsum.pdf',
                        owner_id: '635abb5474b9d697a439f581',
                        uploaded_by: '635abb5474b9d697a439f581',
                        organization_id: '635abb4c74b9d697a439f4ac',
                        parent_id: 'None',
                        status: 'uploaded',
                        active: true,
                        type: 'file',
                        topics: [],
                        processing_metadata: {
                            processing_status: 'completed',
                        },
                        created_at: '2025-04-28T18:05:08.209000',
                        updated_at: '2025-04-28T18:05:30.138000',
                    },
                    {
                        _id: '680feabec03f9b446af59384',
                        name: 'entregas madrid.pdf',
                        title: 'entregas madrid.pdf',
                        owner_id: '635abb5474b9d697a439f581',
                        uploaded_by: '635abb5474b9d697a439f581',
                        organization_id: '635abb4c74b9d697a439f4ac',
                        type: 'file',
                        parent_id: 'None',
                        status: 'uploaded',
                        active: true,
                        topics: [],
                        processing_metadata: {
                            processing_status: 'completed',
                        },
                        created_at: '2025-04-28T20:53:18.224000',
                        updated_at: '2025-04-28T20:53:22.095000',
                    },
                ],
                folders: [
                    {
                        id: '680feabec03f9b446af59384',
                        name: 'entregas',
                        title: 'entregas',
                        owner_id: '635abb5474b9d697a439f581',
                        uploaded_by: '635abb5474b9d697a439f581',
                        organization_id: '635abb4c74b9d697a439f4ac',
                        type: 'folder',
                        parent_id: 'None',
                        status: 'uploaded',
                        active: true,
                        topics: [],
                        processing_metadata: {
                            processing_status: 'completed',
                        },
                        created_at: '2025-04-28T20:53:18.224000',
                        updated_at: '2025-04-28T20:53:22.095000',
                    },
                ],
                pagination: {
                    page: 1,
                    page_size: 10,
                    total_documents: 2,
                    total_pages: 1,
                },
            }),
        ); // simulate success
    }),
    rest.post(AGENTS_API_URL + '/documents/upload', async (req, res, ctx) => {
        return res(
            ctx.status(200),
            ctx.json({
                id: '681a4c86716b812c611c3705',
                filename: 'lorem-ipsum.pdf',
                title: 'lorem-ipsum.pdf',
                size: 77123,
                status: 'uploading',
                uploaded_at: '2025-05-06T17:53:10.726579Z',
                updated_at: null,
                parent_id: null,
                owner_id: null,
                organization_id: null,
                processing_time_ms: 0,
                chunk_count: 0,
                page_count: null,
                tags: [],
                error: null,
            }),
        );
    }),
    rest.post(AGENTS_API_URL + '/documents/v2/upload', async (req, res, ctx) => {
        return res(
            ctx.status(200),
            ctx.json({
                id: '681a4c86716b812c611c3705',
                filename: 'lorem-ipsum.pdf',
                title: 'lorem-ipsum.pdf',
                size: 77123,
                status: 'uploading',
                uploaded_at: '2025-05-06T17:53:10.726579Z',
                updated_at: null,
                parent_id: null,
                owner_id: null,
                organization_id: null,
                processing_time_ms: 0,
                chunk_count: 0,
                page_count: null,
                tags: [],
                error: null,
            }),
        );
    }),
];
